export function minDelay(promise, ms = 2500) {
    return Promise.all([promise, new Promise(resolve => setTimeout(resolve, ms))])
        .then(([result]) => result);
}
